export default __webpack_public_path__ + "static/media/chitkara.a1beb7f0.png";